/* eslint-disable import/no-internal-modules */
import Icon from '@insided/deprecated-preact-components/assets'
import SimplePanel from '@insided/deprecated-control/ui-components/SimplePanel'
import TextField from '@insided/deprecated-preact-components/design-system-components/text-field'
import InputUnit from '@insided/deprecated-preact-components/design-system-components/input-unit'

interface Props {
    requiredFieldsError: {
        title: boolean
        slug: boolean
    }
    title: string
    slug: string
    isSlugReadOnly?: boolean
    onTitleChange: (value: string) => void
    onSlugChange: (value: string) => void
}

const GeneralPanel = ({ requiredFieldsError, title, slug, isSlugReadOnly = false, onTitleChange, onSlugChange }: Props) => (
  <SimplePanel className='custom-pages__general-panel' image={<Icon icon='edit' width={30} height={30} color='#2B3346' />}>
    <div className='custom-page__general-title'><h5>General</h5></div>
    <InputUnit error={requiredFieldsError.title ? 'This field is required' : undefined}>
      <TextField
        defaultValue={title}
        isInline={false}
        size='fullWidth'
        name='custom_page_name'
        label='Page Name'
        ariaLabel='Page Name'
        id='custom_page_name'
        onChange={(e) => onTitleChange(e)}
      />
    </InputUnit>
    <InputUnit error={requiredFieldsError.slug ? 'This field is required' : undefined}>
      <TextField
        defaultValue={slug}
        disabled={isSlugReadOnly}
        isInline={false}
        size='fullWidth'
        name='custom_page_slug'
        label='URL slug'
        subtext='URL slug cannot be edited once set'
        ariaLabel='URL slug'
        id='custom_page_url_slug'
        onChange={(e) => onSlugChange(e)}
      />
    </InputUnit>
  </SimplePanel>)

export default GeneralPanel
